import { site, i18next } from '@yola/ws-sdk';
import getLanguageCodes from 'src/js/modules/website-settings/helpers/get-language-codes';
import verifiers from '../verifiers';

const validatePagePath = (value, pageId) => {
  if (!value) {
    return i18next.t('Publish path must not be empty');
  }

  if (!value.startsWith('/')) {
    return i18next.t('Publish path should start with ‘/‘ symbol');
  }

  if (!verifiers.isPathValid(value)) {
    return i18next.t(
      'Invalid path. Use alphanumeric characters, ‘-’, ‘_’, ‘.’ and ‘/’ symbols only'
    );
  }

  if (value.split('/').filter((item) => item).length > 3) {
    return i18next.t('Publish path cannot contain more than 3 levels');
  }

  const languageCodes = getLanguageCodes();
  const pageSettings = site.accessors.getPage(pageId);
  const isHomePage = site.verifiers.isHomePage(pageSettings.path, languageCodes);
  const isHomePagePath = site.verifiers.isHomePage(value, languageCodes);

  if (!isHomePage && isHomePagePath) {
    return i18next.t('Home page path is not allowed as publish path');
  }

  if (!verifiers.isPathUnique(value, pageId)) {
    return i18next.t('Invalid path. A page with this path already exists');
  }

  if (verifiers.isPathReserved(value)) {
    return i18next.t(
      'Invalid path. The path you specified is reserved by our system and can not be used'
    );
  }

  return null;
};

export default validatePagePath;
